import * as React from 'react';
import { connect } from 'react-redux';
import '../css/SuperUserPageView.css';
import { TooltipCont } from '../../../infrastructure/tooltips';
import { getScrollbarWidth } from '../../../lib/helpers';
import CreateEditComplimentaryLogoModal from '../../Modals/CreateEditComplimentaryLogoModal/CreateEditComplimentaryLogoModal'
import { ILogo } from '../../../infrastructure/interfaces'
import {createComplimentaryLogo, updateComplimentaryLogo, deleteComplimentaryLogo} from '../../../actions/actions'
import HeaderBar from '../../HeaderBar/HeaderBar';
import DeleteConfirmModal from '../../Modals/DeleteConfirmModal';
import { contentImagesRelativePath } from '../../../constants';

export interface IManageComplimentaryLogosProps {
  logos?: ILogo[];
  updateComplimentaryLogo(logoID: number, logoName: string, formData?: FormData): void;
  createComplimentaryLogo(logoName: string, formData: FormData): void;
  deleteComplimentaryLogo(logo: ILogo): void;
}

export interface IManageComplimentaryLogosState {
    showEditModal: boolean;
    showDeleteComplimentaryLogoModal: boolean;
    selectedComplimentaryLogo?: ILogo;
}

const mapStateToProps = (state: any) => {
  return {
    logos: state.wizard.logos,
  };
};

const mapDispatchToProps = (dispatch: any): any => {
  return {
    updateComplimentaryLogo: (logoID: number, logoName: string, formData?: FormData) => {
      dispatch(updateComplimentaryLogo(logoID, logoName, formData));
    },
    createComplimentaryLogo: (logoName: string, formData: FormData) => {
      dispatch(createComplimentaryLogo(logoName, formData));
    },
    deleteComplimentaryLogo: (logo: ILogo) => {
      dispatch(deleteComplimentaryLogo(logo));
    },
  };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class ProductsTable extends React.Component<IManageComplimentaryLogosProps, IManageComplimentaryLogosState> {
  tableRow: HTMLElement;
  constructor(props: IManageComplimentaryLogosProps) {
    super(props);
    this.state = {
      showEditModal: false,
      showDeleteComplimentaryLogoModal: false,
    };
  }

  onEditComplimentaryLogo = (logo: ILogo) => {

    this.setState({
        showEditModal: true,
        showDeleteComplimentaryLogoModal: false,
        selectedComplimentaryLogo: logo
    });

  }

  onDeleteComplimentaryLogoRequest(logo: ILogo) {

    if(logo.id) {
      this.setState({
          showEditModal: false,
          showDeleteComplimentaryLogoModal: true,
          selectedComplimentaryLogo: logo,
      });
    }
  }

  onCreateComplimentaryLogo() {

    this.setState({
        showEditModal: true,
        showDeleteComplimentaryLogoModal: false,
        selectedComplimentaryLogo: undefined,
    });
  }

  deleteComplimentaryLogo(logo: ILogo) {
    this.props.deleteComplimentaryLogo(logo);
  }

  closeModals() {

    this.setState({
      showEditModal: false,
      showDeleteComplimentaryLogoModal: false,
      selectedComplimentaryLogo: undefined,
    });
  }

  render() {

    const {
      logos,
    } = this.props;
    var nonNullComplimentaryLogos = logos ? logos : [];

    return (
      <div className="root-container">
        <HeaderBar />
        <div className="inner-su-container">
          <div className="manage-items-row-offsetRight">

            <div className="in-row-text-container">
              Manage Complimentary Logos
            </div>

            <div className="in-row-button-container">
            
              <button
                className="btn primary-green large"
                onClick={() => {this.onCreateComplimentaryLogo();}}
                title={TooltipCont.CREATE_COMPLIMENTARY_LOGO}
              >
                Create New Logo
              </button>
          </div>
          </div>
          <table className="table-scrollableSU documents-table">
            <thead style={{ paddingRight: getScrollbarWidth() }}>
              <tr>
                <th>Image</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody className="document-table-body">
              {nonNullComplimentaryLogos.map((p: ILogo) =>
                <tr key={p.id} ref={tr => this.tableRow = tr!}>
                  <td>
                    <img className="inlineImagesTableImage" src={contentImagesRelativePath + p.image} />
                  </td>
                  <td>
                    <div className="button-wrapper">
                      <button
                        className="btn primary-blue"
                        onClick={() => this.onEditComplimentaryLogo(p)}
                        title={TooltipCont.EDIT}
                        disabled={false}
                      >
                        Edit
                      </button>
                      <button
                        className="btn primary-red"
                        onClick={() => this.onDeleteComplimentaryLogoRequest(p)}
                        title={TooltipCont.DELETE}
                        disabled={false}
                      >
                        Delete
                      </button>
                      
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>

          <CreateEditComplimentaryLogoModal
              show={this.state.showEditModal}
              onClose={() => this.closeModals()}
              logo={this.state.selectedComplimentaryLogo}
              updateComplimentaryLogo={this.props.updateComplimentaryLogo}
              createComplimentaryLogo={this.props.createComplimentaryLogo}
          />

          <DeleteConfirmModal
              show={this.state.showDeleteComplimentaryLogoModal}
              onClose={() => this.closeModals()}
              onSave={() => {
                  if(this.state.selectedComplimentaryLogo && this.state.selectedComplimentaryLogo.id) {
                    this.deleteComplimentaryLogo(this.state.selectedComplimentaryLogo);
                  }
                  this.closeModals();
              }}
              title={(this.state.selectedComplimentaryLogo)
                ? 'Delete Complimentary Logo "' + this.state.selectedComplimentaryLogo.title + '"?'
                : 'Error. Please go back.'}
          />
        </div>
      </div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/SuperUser/components/ManageComplimentaryLogos.tsx